require("./styles/style.scss");